import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    render: (name, row) => (
      <Link to={ROUTES.CLIENT_CONFIG_EDIT.replace(':targetClientId', row.clientId)}>
        {name}
      </Link>
    ),
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Live View Enabled',
    dataIndex: 'liveViewEnabled',
    render: liveViewEnabled => (liveViewEnabled ? 'True' : 'False'),
    sorter: (a, b) => a.liveViewEnabled.localeCompare(b.liveViewEnabled)
  },
  {
    title: 'Since',
    dataIndex: 'since',
    sorter: (a, b) => a.since.localeCompare(b.since)
  },
  {
    title: 'Visit Calculation Enabled',
    dataIndex: 'visitCalculationEnabled',
    render: visitCalculationEnabled => (visitCalculationEnabled ? 'True' : 'False'),
    sorter: (a, b) => a.visitCalculationEnabled.localeCompare(b.visitCalculationEnabled)
  },
  {
    title: 'Live Visit Enabled',
    dataIndex: 'liveVisitEnabled',
    render: liveVisitEnabled => (liveVisitEnabled ? 'True' : 'False'),
    sorter: (a, b) => a.liveVisitEnabled.localeCompare(b.liveVisitEnabled)
  },
  {
    title: 'Grace Period',
    dataIndex: 'liveVisitGracePeriod',
    sorter: (a, b) => a.liveVisitGracePeriod.localeCompare(b.liveVisitGracePeriod)
  },
  {
    title: 'Merge Period',
    dataIndex: 'liveVisitMergePeriod',
    sorter: (a, b) => a.liveVisitMergePeriod.localeCompare(b.liveVisitMergePeriod)
  }
]

const ListView = ({ clients }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {clients.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {clients.length} client configs
      </PageContentUnderTitle>
    )}
    <Table dataSource={clients} columns={columns} pagination={false} rowKey="clientId" />
  </div>
)

export default ListView



// WEBPACK FOOTER //
// ./src/pages/client-config/clientconfig-list/components/list-view/index.js